import React from 'react';
import {Link} from 'gatsby';
import {GatsbyImage, getImage,} from 'gatsby-plugin-image';

interface DataContext {
  drupalData: Queries.paragraph__highlighted_links;
}

export default function HighlightedLinks({drupalData}: DataContext): React.JSX.Element {
  return (
    <section className="vl-region">
      <div className="vl-layout">
        <div className="vl-grid vl-grid--is-stacked">
          {drupalData.relationships.field_links.map(
            (linkParagraph: Queries.paragraph__link, idx) => {
              const imageAlt = linkParagraph.relationships?.field_media?.field_media_image?.alt;
              const gatsbyImage = linkParagraph.relationships?.field_media?.relationships?.field_media_image;
              const image = getImage(gatsbyImage);

              return drupalData.field_display_images && image ? (
                <div
                  key={idx}
                  className="vl-col--4-12 vl-col--6-12--m vl-col--12-12--s"
                >
                  <Link
                    to={linkParagraph?.field_link?.url}
                    className="vl-spotlight vl-spotlight--image"
                    style={{height: '100%'}}
                  >
                    <header role="none" className="vl-spotlight__header">
                      <div className="vl-spotlight__image vl-spotlight__image--focus-center-center">
                        <GatsbyImage
                          className="vl-spotlight__image__img"
                          image={image}
                          alt={imageAlt}
                        />
                      </div>

                      <h3 className="vl-title vl-title--h2">
                        {linkParagraph.field_title}
                      </h3>
                    </header>

                    <p className="vl-spotlight__text">
                      {linkParagraph.field_description}
                    </p>
                  </Link>
                </div>
              ) : (
                <div
                  key={idx}
                  className="vl-col--4-12 vl-col--6-12--m vl-col--12-12--s"
                >
                  <Link
                    to={linkParagraph?.field_link?.url}
                    className="vl-spotlight vl-spotlight--link vl-spotlight--alt"
                    style={{height: '100%'}}
                  >
                    <h3 className="vl-spotlight__title">
                      {linkParagraph.field_title}
                    </h3>
                    <p className="vl-spotlight__text">
                      {linkParagraph.field_description}
                    </p>
                  </Link>
                </div>
              );
            },
          )}
        </div>
      </div>
    </section>
  );
}
